// extracted by mini-css-extract-plugin
module.exports = {"metaData":"style_metaData__3NoMc","xenero":"style_xenero__3eb9w","fecha":"style_fecha__uiaR8","temporadas":"style_temporadas__UR5R0"};